var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[(!_vm.certsExist)?_c('PageContainer',{scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('PkiGettingStarted')]},proxy:true}],null,false,3645591785)}):_vm._e(),(!_vm.hidePageTabs)?_c('PageTabs',{attrs:{"tabConfig":_vm.$options.tabConfig}},[_c('router-view')],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }